import { UserManager, WebStorageStateStore } from 'oidc-client-ts'
import Const from '../Utils/Consts'

const userManager = new UserManager({
  client_id: Const.env.REACT_APP_CLIENT_ID,
  redirect_uri: Const.RedirectUri,
  // silent_redirect_uri: Const.SilentRedirectUri,
  response_type: Const.ResponseType,
  scope: Const.env.REACT_APP_SCOPES,
  authority: Const.env.REACT_APP_IDENTITY_URL,
  post_logout_redirect_uri: Const.PostLogoutRedirectUri,
  userStore: new WebStorageStateStore({ store: localStorage }),
  automaticSilentRenew: false,
  //filterProtocolClaims: true,
  loadUserInfo: true,
  monitorSession: true,
  // clockSkew: Const.env.REACT_APP_CLOCK_SKEW,
  // silentRequestTimeout: 1,
  // client_secret: Const.ClientSecret,
  metadata: {
    issuer: 'https://www.fanapium.com/',
    authorization_endpoint:
      Const.env.REACT_APP_REACT_FAKE_USER == false
        ? `${Const.env.REACT_APP_IDENTITY_URL}oauth2/authorize`
        : `${Const.env.REACT_APP_API_GATEWAY_URL}digital_software_management/api/AuthenticationPodFakeUser/authorize`,
    token_endpoint:
      Const.env.REACT_APP_REACT_FAKE_USER == false
        ? `${Const.env.REACT_APP_API_GATEWAY_URL}digital_software_management/api/AuthenticationPod/token`
        : `${Const.env.REACT_APP_API_GATEWAY_URL}digital_software_management/api/AuthenticationPodFakeUser/token`,
    userinfo_endpoint:
      Const.env.REACT_APP_REACT_FAKE_USER == false
        ? `${Const.env.REACT_APP_IDENTITY_URL}users`
        : `${Const.env.REACT_APP_API_GATEWAY_URL}digital_software_management/api/AuthenticationPodFakeUser/User`,
    // authorization_endpoint: `${Const.env.REACT_APP_IDENTITY_URL}oauth2/authorize`,
    // token_endpoint: `${Const.env.REACT_APP_API_GATEWAY_URL}digital_software_management/api/AuthenticationPod/token`,
    // userinfo_endpoint: `${Const.env.REACT_APP_IDENTITY_URL}users`,

    end_session_endpoint: `${Const.env.REACT_APP_IDENTITY_URL}oauth2/endSession`,
  },
  extraQueryParams: {
    prompt: Const.env.REACT_APP_LOGIN_TYPE == 'OTP' ? 'otp_login' : '',
  },
  validateSubOnSilentRenew: false,
})

export default userManager
